import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiHome } from 'react-icons/fi';
import SeoHead from '../components/SeoHead';

const NotFoundPage = () => (
  <>
    <SeoHead
      title="Page not found"
      description="The page you were looking for doesn't exist."
      path="/404"
      noindex
    />
    <header className="page-header">
      <div className="container" style={{ textAlign: 'center' }}>
        <span className="section-eyebrow">404</span>
        <h1>This page wandered off.</h1>
        <p>
          The link may be broken or the page may have moved. Let's get you back
          on track.
        </p>
        <div
          style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center',
            marginTop: '24px',
            flexWrap: 'wrap',
          }}
        >
          <Link to="/" className="btn btn-accent">
            <FiHome /> Back to home
          </Link>
          <Link to="/contact" className="btn btn-ghost">
            <FiArrowLeft /> Contact us
          </Link>
        </div>
      </div>
    </header>
  </>
);

export default NotFoundPage;
